import { HeaderBar } from '@fortem-monorepo/react-spa'

import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { SMARTRADE_LINKS } from '@/constants/links'

export interface SmartradeLayoutProps {}

export const SmartradeLayout: React.FC<SmartradeLayoutProps> = ({}) => {
  return (
    <>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={SMARTRADE_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <LayoutOutlet />
    </>
  )
}
